import { RegistryTypes } from '@/core/models/registryTypes';

angular.module('shbdeployer.app').controller('RegistryController', [
  '$scope',
  '$state',
  'RegistryService',
  'Notifications',
  function ($scope, $state, RegistryService, Notifications) {
    $scope.state = {
      actionInProgress: false,
    };

    $scope.formValues = {
      Password: '',
    };

    $scope.RegistryTypes = RegistryTypes;

    $scope.updateRegistry = function () {
      var registry = $scope.registry;
      registry.Password = $scope.formValues.Password;
      $scope.state.actionInProgress = true;
      RegistryService.updateRegistry(registry)
        .then(function success() {
          Notifications.success('Реестр образов обновлен');
          $state.go('shbdeployer.registries');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось обновить реестр образов');
        })
        .finally(function final() {
          $scope.state.actionInProgress = false;
        });
    };

    function initView() {
      var registryID = $state.params.id;
      RegistryService.registry(registryID)
        .then(function success(data) {
          $scope.registry = data;
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить сведения о реестре образов');
        });
    }

    initView();
  },
]);
